import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CSidebar, CSidebarHeader, CSidebarToggler, CCloseButton } from '@coreui/react-pro'
import { AppSidebarNav } from './AppSidebarNav'
import navigation from '../_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const user = useSelector((state) => state.user) // Accessing user data from Redux store

  const userName = user?.name || 'Guest' // Fallback to 'Guest' if no name is found
  const userRole = user?.role || 'User' // Fallback to 'User' if no role is found

  return (
    <CSidebar
      colorScheme="light"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarHeader>
        <div className="profileDetails">
          <div className="profileIconBox">
            {userName
              .split(' ')
              .map((n) => n[0])
              .join('')}{' '}
            {/* Initials from user name */}
          </div>
          <div className="profileTextBox">
            <h5>{userName}</h5> {/* Display dynamic user name */}
            <p>{userRole}</p> {/* Display dynamic user role */}
          </div>
        </div>
        <CCloseButton
          className="d-lg-none"
          dark
          onClick={() => dispatch({ type: 'set', sidebarShow: false })}
        />
        <CSidebarToggler
          onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
        />
      </CSidebarHeader>
      <AppSidebarNav items={navigation} />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
